import PropTypes from 'prop-types';

const defaultProps = {
  excerpt: null,
};

const propTypes = {
  excerpt: PropTypes.string,
  content: PropTypes.string.isRequired,
};

export default function CertificationContent({ excerpt, content }) {
  return (
    <div className="prose space-y-10 lg:prose-lg">
      {excerpt && (
        <div className="lead">
          <div
            className="text-gray-900"
            dangerouslySetInnerHTML={{ __html: excerpt }}
          />
        </div>
      )}
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}

CertificationContent.defaultProps = defaultProps;
CertificationContent.propTypes = propTypes;
